import { render, staticRenderFns } from "./CategoriasEditar.vue?vue&type=template&id=0b916081"
import script from "./CategoriasEditar.vue?vue&type=script&lang=js"
export * from "./CategoriasEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports